const apiUrl = process.env.REACT_APP_API_URL;
export const PostRemesaAlgoritmisDocument = async (id: string, page: string, token: string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/algoritmix/remesa/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (response.ok) {
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } else {
            alert(await response.text());
        }
        return "";

    } catch (error) {
        console.log('Error al descargar el documento:', error);
        return "";
    }
};
